import { useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Volume2, VolumeX, Gift, DoorOpen, Sparkles, ChevronDown, Award } from "lucide-react";
import { useSound } from "../sound";

export const MelaTopBar = ({ state, onRewards, onBadges }) => {
  const { rawSoundOn, toggleSound } = useSound();
  const [showOpps, setShowOpps] = useState(false);
  const lvl = state.level || {};
  const badgeCount = (state.badges || []).filter((b) => b.earned).length;
  const progress = lvl.next_at ? Math.min(100, Math.round((state.mela_lifetime / lvl.next_at) * 100)) : 100;
  const guest = state.nickname || state.name || "Mela Guest";

  return (
    <div data-testid="mela-topbar" className="sticky top-14 z-30 -mx-4 px-4 py-2 bg-[#120C05]/95 backdrop-blur-md border-b border-[#8a6d1f]/30">
      <div className="flex items-center gap-2 flex-wrap">
        <span data-testid="mela-guest-name" className="text-[11px] font-bold text-white/70 truncate max-w-[110px]">{guest}</span>
        <span data-testid="mela-topbar-points" className="flex items-center gap-1 rounded-full border border-[#D4AF37]/50 bg-[#1C160A] px-2.5 py-1 text-[11px] font-black text-[#D4AF37]">
          <Coins size={11} /> {state.points} <span className="hidden sm:inline text-[8px] tracking-widest text-white/45 font-bold">URBAN PTS</span>
        </span>
        <span data-testid="mela-topbar-nanakshahi" className="flex items-center gap-1 rounded-full border border-[#E25822]/50 bg-[#1C1006] px-2.5 py-1 text-[11px] font-black text-[#F0C742]">
          <img src="/mela/coin.png" alt="Regal Coin" className="w-4 h-4 object-contain" /> {state.mela_score}
          <span className="hidden sm:inline text-[8px] tracking-widest text-white/45 font-bold">REGAL COINS</span>
        </span>
        <span data-testid="mela-topbar-level" title={lvl.next_name ? `${state.mela_lifetime}/${lvl.next_at} to ${lvl.next_name}` : "Max level!"}
          className="flex items-center gap-1.5 rounded-full border border-white/15 bg-[#151008] px-2.5 py-1">
          <span className="text-[10px] font-black text-white/80">{(lvl.name || "").toUpperCase()}</span>
          <span className="w-10 h-1.5 rounded-full bg-white/10 overflow-hidden"><span className="block h-full bg-[#D4AF37]" style={{ width: `${progress}%` }} /></span>
        </span>
        <div className="flex items-center gap-1.5 ml-auto">
          {(state.opportunities || []).length > 0 && (
            <button data-testid="mela-today-btn" onClick={() => setShowOpps(!showOpps)}
              className="flex items-center gap-1 rounded-full bg-[#E25822] text-white px-2.5 py-1.5 text-[9px] font-black tracking-widest">
              <Sparkles size={10} /> TODAY ({state.opportunities.length}) <ChevronDown size={10} className={showOpps ? "rotate-180" : ""} />
            </button>
          )}
          <button data-testid="mela-badges-btn" onClick={onBadges} aria-label="My mela badges"
            className="relative w-8 h-8 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] flex items-center justify-center">
            <Award size={13} />
            {badgeCount > 0 && (
              <span className="absolute -top-1 -right-1 min-w-[14px] h-[14px] rounded-full bg-[#E25822] text-white text-[8px] font-black flex items-center justify-center px-0.5">{badgeCount}</span>
            )}
          </button>
          <button data-testid="mela-rewards-btn" onClick={onRewards} aria-label="My arcade rewards"
            className="w-8 h-8 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] flex items-center justify-center"><Gift size={13} /></button>
          <button data-testid="mela-sound-btn" onClick={toggleSound} aria-label={rawSoundOn ? "Sound off" : "Sound on"}
            className={`w-8 h-8 rounded-full border flex items-center justify-center ${rawSoundOn ? "border-[#D4AF37] bg-[#D4AF37] text-black" : "border-white/20 text-white/50"}`}>
            {rawSoundOn ? <Volume2 size={13} /> : <VolumeX size={13} />}
          </button>
          <Link data-testid="mela-exit-btn" to="/menu" aria-label="Exit to menu"
            className="w-8 h-8 rounded-full border border-white/20 text-white/60 flex items-center justify-center"><DoorOpen size={13} /></Link>
        </div>
      </div>
      {showOpps && (
        <div data-testid="mela-opportunities" className="mt-2 rounded-xl border border-[#D4AF37]/25 bg-[#1A1208] p-3 space-y-1.5">
          <p className="text-[9px] tracking-[0.25em] text-[#D4AF37] font-black">TODAY'S EARNING CHANCES</p>
          {state.opportunities.map((o, i) => (
            <p key={i} className="text-[11px] text-white/70 flex items-center gap-1.5">
              <span className="w-1 h-1 rounded-full bg-[#E25822]" /> {o.label}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
